import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import CustomBoard from "../../../../components/CustomBoard";
import Color from "../../../../../utils/Color";
import "fontsource-muli";
import CustomTextInput from "../../../../components/CustomTextInput";
import CustomButton from "../../../../components/CustomButton";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as selector from "../../../../../common/selectors";
import * as registrationSelector from "../../../../../common/selectors/registration";
import * as registrationAction from "../../../../../common/actions/registration";
import CustomToast from "../../../../components/CustomToast";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import AuthManager from "../../../../../utils/AuthManager";

class ActivationGenericLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nric: "",
      dob: "",
      userID: "",
      newPassword: "",
      confirmPassword: "",
      height: 0,
      customToastStatus: false,
      toastMessage: "",
      genericLinkAction: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate() {
    const {
      activationGenericLinkReqData,
      activationGenericLinkReqStatus,
      activationGenericLinkReqLoading,
    } = this.props;
  

    if (
      activationGenericLinkReqStatus === true &&
      activationGenericLinkReqData !== null &&
      activationGenericLinkReqLoading === false
    ) {
      const otpReference = registrationSelector.activationOtpReference(
        activationGenericLinkReqData
      );
      const { history } = this.props;
      AuthManager.setNric(this.state.nric);
      AuthManager.setOtpReference(otpReference);
      AuthManager.setUserID(this.state.userID);
      AuthManager.setPassword(this.state.confirmPassword);
      // history.push("/prototype/ActivationGenericOTP", {
      //   nric: this.state.nric,
      //   otpReference: otpReference,
      //   userID: this.state.userID,
      //   password: this.state.confirmPassword,
      // });
      history.push("/ActivationGenericOTP");
      
    }

    
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  onChangeNRIC = (event) => {
    this.setState({ nric: event.target.value });
  };

  onChangeDOB = (event) => {
    this.setState({ dob: event.target.value });
  };

  onChangeUserID = (event) => {
    this.setState({ userID: event.target.value });
  };

  onChangeNewPassword = (event) => {
    this.setState({ newPassword: event.target.value });
  };

  onChangeConfirmPassword = (event) => {
    this.setState({ confirmPassword: event.target.value });
  };

  onClickSubmit = () => {
    const { nric, dob, userID, newPassword, confirmPassword } = this.state;
    const {
      activationGenericLinkRequest,
      activationGenericLinkReqData,
     
    } = this.props;
    activationGenericLinkRequest(
      userID,
      newPassword,
      confirmPassword,
      nric,
      dob
    );
  
   

    this.setState({ genericLinkAction: true });
  };

  handleCloseCustomToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ customToastStatus: false });
  };


  renderChildren = () => {
    const { classes } = this.props;
    const { nric, dob, userID, newPassword, confirmPassword } = this.state;
    return (
      <div>
        <CustomText design={classes.headerTextStyle}>
          Etiqa Customer Onboarding
        </CustomText>
        <div className={classes.inputContainer}>
          <div>
            <CustomTextInput
              title={"NRIC/Passport/FIN No."}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={nric}
              onChange={this.onChangeNRIC}
            />
          </div>

          <div style={{ marginTop: 15 }}>
            <CustomTextInput
              title={"Date of Birth (in DDMMYYYY)"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={dob}
              onChange={this.onChangeDOB}
            />
          </div>
          <div style={{ marginTop: 15 }}>
            <CustomTextInput
              title={"User ID"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={userID}
              onChange={this.onChangeUserID}
            />
          </div>
          <div style={{ marginTop: 15 }}>
            <CustomTextInput
              id="outlined-adornment-password"
              type={"password"}
              title={"New Password"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={newPassword}
              onChange={this.onChangeNewPassword}
            />
          </div>
          <div style={{ marginTop: 15 }}>
            <CustomTextInput
              id="outlined-adornment-password"
              type={"password"}
              title={"Confirm Password"}
              textstyle={classes.labelTextInputTextStyle}
              design={classes.textInputContainer}
              fullWidth={true}
              value={confirmPassword}
              onChange={this.onChangeConfirmPassword}
            />
          </div>
        </div>

        <CustomButton
          title={"Submit"}
          design={classes.buttonStyle}
          onClick={this.onClickSubmit}
        />
      </div>
    );
  };

  render() {
    const { classes,activationGenericLinkReqLoading } = this.props;
    const { height } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoard children={this.renderChildren()} height={height} />
        <CustomToast
          open={this.state.customToastStatus}
          handleCloseCustomToast={this.handleCloseCustomToast}
          title={this.state.toastMessage}
          warning
        />
        {activationGenericLinkReqLoading ? (
          <LoadingOverlay loading={true} />
        ) : (
          false
        )}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  headerTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
  },
  labelTextInputTextStyle: {
    ...getFontWeight("600"),
    ...getFontSize("medium"),
    color: Color.primaryTextColor,
  },
  textInputContainer: {
    height: 40,
    marginTop: 5,
  },
  inputContainer: {
    marginTop: 40,
  },
  buttonStyle: {
    width: 120,
    marginTop: 30,
  },
});

function mapStateToProps(state) {
  return {
    activationGenericLinkReqData: selector.activationGenericLinkReqData(state),
    activationGenericLinkReqLoading: selector.activationGenericLinkReqLoading(
      state
    ),
    activationGenericLinkReqStatus: selector.activationGenericLinkReqStatus(
      state
    ),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    activationGenericLinkRequest: (
      userID,
      password,
      confirmPassword,
      nric,
      dob
    ) =>
      dispatch(
        registrationAction.activationGenericLinkRequest(
          userID,
          password,
          confirmPassword,
          nric,
          dob
        )
      ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(withRouter(ActivationGenericLink)));
